var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"qa-page qa-page--standalone"},[(_vm.questionVisible)?_c('MobileQuestion',{attrs:{"MobileQAList":_vm.MobileQAList,"getIndex":_vm.getIndex,"questionVisible":_vm.questionVisible}}):_vm._e(),(_vm.answerVisible)?_c('MobileAns',{attrs:{"AnswerList":_vm.AnswerList,"back":_vm.back}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }